module.exports = __webpack_public_path__ + "static/media/Bluepassport.a7d486f4.svg";